import { useState } from "react";

import { Button, Group } from "@mantine/core";

import { PostpartumFlowsheetQuickButton } from "@/encounters/components/EncounterLabor/constants/postpartum-flowsheets";
import { EncounterLaborQuickButtonDrawer } from "@/encounters/components/EncounterLabor/EncounterLaborDrawer/EncounterLaborQuickButtonDrawer";

export interface PostpartumFlowsheetQuickButtonsProps {
  encounterId: string;
  clientId: string;
  flowSheetButtons: readonly PostpartumFlowsheetQuickButton[];
  onRefresh?: () => Promise<void>;
}

export function PostpartumFlowsheetQuickButtons({
  encounterId,
  clientId,
  flowSheetButtons,
  onRefresh,
}: PostpartumFlowsheetQuickButtonsProps) {
  const [opened, setOpened] = useState(false);
  const [selectedFlow, setSelectedFlow] = useState<PostpartumFlowsheetQuickButton | null>(null);

  return (
    <>
      <Group gap="sm" data-testid="postpartum-flowsheet-quick-buttons">
        {flowSheetButtons.map((flow) => (
          <Button
            size="xs"
            key={flow.title}
            color="burgundy"
            variant="outline"
            data-testid={`postpartum-flowsheet-quick-button-${flow.title}`}
            onClick={() => {
              setSelectedFlow(flow);
              setOpened(true);
            }}
          >
            {flow.title}
          </Button>
        ))}
      </Group>
      {selectedFlow && (
        <EncounterLaborQuickButtonDrawer
          opened={opened}
          clientId={clientId}
          onRefresh={onRefresh}
          encounterId={encounterId}
          flowsheetContext="postpartum"
          onClose={() => setOpened(false)}
          questionnaireTitle={selectedFlow.displayTitle}
          questionnaireName={selectedFlow.questionnaireName}
        />
      )}
    </>
  );
}
